var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplay)?_c('div',{staticClass:"content-loader"},[_c('img',{staticClass:"spinner",attrs:{"src":require("@/assets/loader.png"),"alt":"loading","title":"loading"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }